const number = require("./number");
const date = require("./date");
const time = require("./time");
const mobile = require("./mobile");

const en = {
  number: number,
  date: date,
  time: time,
  mobile: mobile,
};

module.exports = en;
